<template>
  <div class="invitation-page">
    <header class="invitation-header">
      <button class="invitation-back" type="button" :aria-label="$t('Back')" @click="back">
        <img src="../../static/images/livequiz/back.png" alt="" />
      </button>
    </header>

    <main class="invitation-content">
      <img class="invitation-title" src="../../static/images/invitation/invite_title.png" :alt="$t('invitation')" />

      <section class="invite-panel">
        <div class="invite-link-wrap">
          <img src="../../static/images/invitation/Link.png" alt="" />
          <input :value="invite_url" readonly :aria-label="$t('invitation')" />
        </div>

        <button id="copycode" class="invite-copy" type="button" :data-clipboard-text="invite_url" @click="copy">
          <img src="../../static/images/invitation/copy_btn_bg.png" alt="" />
          <span>{{ $t('copy') }}</span>
        </button>

        <section class="share-panel" :aria-label="$t('sharePanelTitle')">
          <div class="share-heading">
            <img src="../../static/images/invitation/share_with_bg.png" alt="" />
            <strong>{{ $t('sharePanelTitle') }}</strong>
            <p>{{ $t('sharePanelTips') }}</p>
          </div>

          <div class="share-grid">
            <button v-for="item in sharePlatforms" :key="item.type" class="share-card" type="button" @click="shareTo(item.type)">
              <img class="share-card-bg" src="/static/images/invitation/App%20BG.png" alt="" />
              <img :src="getShareIconSrc(item.type)" :alt="item.label" />
              <span>{{ item.label }}</span>
            </button>
            <button v-if="canUseNativeShare" class="share-card" type="button" @click="shareTo('native')">
              <img class="share-card-bg" src="/static/images/invitation/App%20BG.png" alt="" />
              <img :src="getShareIconSrc('native')" :alt="$t('shareMore')" />
              <span>{{ $t('shareMore') }}</span>
            </button>
          </div>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  data () {
    return {
      invite_url: '',
      info: {},
      allPlatforms: [
        {type: 'whatsapp', label: 'Whatsapp'},
        {type: 'telegram', label: 'Telegram'},
        {type: 'line', label: 'LINE'},
        {type: 'messenger', label: 'Messenger'},
        {type: 'viber', label: 'Viber'}
      ]
    }
  },
  created () {
    this.getUserInfo()
  },
  computed: {
    canUseNativeShare () {
      return !!navigator.share
    },
    sharePlatforms () {
      if (/iphone|ipad|ipod/i.test(navigator.userAgent || '')) {
        return [{type: 'whatsapp', label: 'Whatsapp'}]
      }
      return this.allPlatforms
    }
  },
  methods: {
    getUserInfo () {
      this.$api.get('/api/user/info', null, r => {
        this.$parent.returnCode(r, () => {
          this.invite_url = r.data.invite_url
          this.info = r.data
        })
      })
    },
    back () {
      this.$router.go(-1)
    },
    copy () {
      const clipboard = new Clipboard('#copycode')
      clipboard.on('success', () => {
        this.$utils.alertText(this.$t('CopySucceeded'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        clipboard.destroy()
      })
    },
    getShareIconSrc (type) {
      const icons = {
        whatsapp: 'whatsapp.png',
        telegram: 'telegram.png',
        line: 'line.png',
        messenger: 'messenger.png',
        viber: 'viber.png',
        native: 'more_options.png'
      }
      return 'static/images/invitation/' + icons[type]
    },
    isAndroidDevice () {
      return /android/i.test(navigator.userAgent || '')
    },
    getShareTarget (type) {
      const url = this.info.invite_url
      const text = this.$t('referralTips1').replace(/<[^>]*>/g, '')
      const encodedUrl = encodeURIComponent(url)
      const encodedText = encodeURIComponent(text)
      const encodedMessage = encodeURIComponent(text + '\n' + url)
      return {
        whatsapp: {
          intentUrl: 'intent://send/?text=' + encodedMessage + '#Intent;scheme=whatsapp;package=com.whatsapp;end',
          schemeUrl: 'whatsapp://send?text=' + encodedMessage,
          webUrl: 'https://wa.me/?text=' + encodedMessage
        },
        telegram: {
          intentUrl: 'intent://msg_url?url=' + encodedUrl + '&text=' + encodedText + '#Intent;scheme=tg;package=org.telegram.messenger;end',
          schemeUrl: 'tg://msg_url?url=' + encodedUrl,
          webUrl: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + encodedText
        },
        line: {
          intentUrl: 'intent://msg/text/' + encodedMessage + '#Intent;scheme=line;package=jp.naver.line.android;end',
          schemeUrl: 'line://msg/text/' + encodedMessage,
          webUrl: 'https://social-plugins.line.me/lineit/share?url=' + encodedUrl
        },
        messenger: {
          intentUrl: 'intent://share?link=' + encodedUrl + '#Intent;scheme=fb-messenger;package=com.facebook.orca;end',
          schemeUrl: 'fb-messenger://share?link=' + encodedUrl,
          webUrl: 'https://www.facebook.com/dialog/send?link=' + encodedUrl + '&app_id=291494419107518&redirect_uri=' + encodedUrl
        },
        viber: {
          intentUrl: 'intent://forward?text=' + encodedMessage + '#Intent;scheme=viber;package=com.viber.voip;end',
          schemeUrl: 'viber://forward?text=' + encodedMessage,
          webUrl: 'viber://forward?text=' + encodedMessage
        }
      }[type] || {}
    },
    openShareLink (url) {
      const popup = window.open(url, '_blank', 'noopener=yes,noreferrer=yes')
      if (popup) popup.opener = null
      else window.location.href = url
    },
    launchWithFallback (intentUrl, schemeUrl) {
      let hidden = false
      const cleanup = () => {
        document.removeEventListener('visibilitychange', onVisibilityChange)
        window.removeEventListener('pagehide', onPageHide)
      }
      const onVisibilityChange = () => {
        if (document.hidden) {
          hidden = true
          cleanup()
        }
      }
      const onPageHide = () => {
        hidden = true
        cleanup()
      }
      document.addEventListener('visibilitychange', onVisibilityChange)
      window.addEventListener('pagehide', onPageHide)
      window.location.href = intentUrl || schemeUrl
      setTimeout(() => {
        if (!hidden && schemeUrl) window.location.href = schemeUrl
        cleanup()
      }, 250)
    },
    shareTo (type) {
      if (!this.info.invite_url) {
        this.$utils.alertText(this.$t('CopySucceeded'))
        return
      }
      if (type === 'native') {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: this.$t('referralTips1').replace(/<[^>]*>/g, ''),
            url: this.info.invite_url
          })
        }
        return
      }
      const target = this.getShareTarget(type)
      if (this.isAndroidDevice() && (target.intentUrl || target.schemeUrl)) {
        this.launchWithFallback(target.intentUrl, target.schemeUrl)
      } else if (target.webUrl) {
        this.openShareLink(target.webUrl)
      }
    }
  }
}
</script>

<style scoped>
.invitation-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 46px 28px 96px;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center top;
  background-size: 100% auto;
  color: #fff;
  font-family: Arial, Atom-sans, sans-serif;
}

.invitation-page::before {
  position: fixed;
  z-index: 0;
  inset: 0;
  content: '';
  background: linear-gradient(180deg, rgba(12, 0, 44, .04), rgba(8, 0, 34, .48) 58%, rgba(7, 0, 29, .9));
  pointer-events: none;
}

.invitation-header {
  position: absolute;
  z-index: 2;
  top: 46px;
  right: 0;
  left: 0;
  width: calc(100% - 56px);
  max-width: 650px;
  margin: 0 auto;
}

.invitation-back {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.invitation-back img { display: block; width: 100%; height: 100%; object-fit: contain; }

.invitation-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}

.invitation-title {
  display: block;
  width: min(100%, 650px);
  margin: 0 auto 28px;
}

.invite-panel {
  box-sizing: border-box;
  aspect-ratio: 1046 / 1347;
  margin: 0 -14px;
  padding: 30px 36px 40px;
  background: transparent url('../../static/images/invitation/invite_bg.png') center/100% 100% no-repeat;
}

.invite-link-wrap {
  position: relative;
  aspect-ratio: 993 / 143;
  margin: 0 0 30px;
}

.invite-link-wrap > img {
  display: block;
  width: 100%;
  height: 100%;
}

.invite-link-wrap input {
  position: absolute;
  inset: 0 7%;
  width: 86%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  outline: 0;
  color: #fff;
  background: transparent;
  font: inherit;
  font-size: clamp(14px, 4vw, 27px);
  text-align: center;
}

.invite-copy {
  position: relative;
  display: block;
  width: 76%;
  aspect-ratio: 754 / 167;
  margin: 0 auto 40px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
}

.invite-copy img { display: block; width: 100%; height: 100%; }
.invite-copy span { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: clamp(19px, 5.3vw, 35px); font-weight: 700; text-shadow: 0 3px 5px rgba(50, 0, 25, .65); }

.share-panel {
  box-sizing: border-box;
  padding: 30px 24px 24px;
  border-radius: 26px;
  background: #08021e url('../../static/images/invitation/app_bg.png') center/100% 100% no-repeat;
}

.share-heading {
  position: relative;
  min-height: 130px;
  padding: 22px 22px 10px;
  text-align: center;
}

.share-heading > img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: fill; }
.share-heading strong, .share-heading p { position: relative; z-index: 1; margin: 0; }
.share-heading strong { display: block; color: #fff; font-size: clamp(19px, 5vw, 34px); font-weight: 900; line-height: 1.1; text-transform: uppercase; }
.share-heading p { margin-top: 9px; color: #ffe869; font-size: clamp(13px, 3.4vw, 23px); line-height: 1.18; }

.share-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 22px;
  gap: 12px;
}

.share-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 150px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px 4px;
  border: 0;
  border-radius: 16px;
  color: #fff;
  background: #28233c;
  cursor: pointer;
}

.share-card:active { transform: scale(.97); }
.share-card-bg { position: absolute; inset: 0; z-index: 0; width: 100% !important; height: 100% !important; }
.share-card > img:not(.share-card-bg), .share-card span { position: relative; z-index: 1; }
.share-card > img:not(.share-card-bg) { display: block; width: 53px; height: 53px; object-fit: contain; }
.share-card span { margin-top: 7px; font-size: clamp(12px, 3.4vw, 22px); line-height: 1.05; text-align: center; }

@media (min-width: 760px) {
  .invitation-title { margin-bottom: 42px; }
  .invite-panel { padding: 48px 58px 60px; }
  .invite-link-wrap { margin-bottom: 48px; }
  .invite-copy { margin-bottom: 58px; }
  .share-panel { padding: 44px 34px 34px; }
  .share-heading { min-height: 185px; padding-top: 32px; }
  .share-grid { gap: 16px; }
  .share-card { min-height: 210px; border-radius: 24px; }
  .share-card img { width: 84px; height: 84px; }
}
</style>



// WEBPACK FOOTER //
// src/page/invitation.vue